export function isCordova() {
  return window.hasOwnProperty('cordova');
}
